"use strict";
'kiwi public';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _default = exports.default = {
  data() {
    return {
      closing: false
    };
  },
  computed: {
    styleCommon() {
      let style = {};
      let options = this.$state.settings.startupOptions;
      if (options.infoBackground && this.$state.ui.app_width <= 850) {
        style['background-image'] = `url("${options.infoBackground}")`;
      }
      return style;
    },
    styleInfo() {
      let style = {};
      let options = this.$state.settings.startupOptions;
      if (options.infoBackground && this.$state.ui.app_width > 850) {
        style['background-image'] = `url("${options.infoBackground}")`;
      }
      return style;
    },
    backgroundImage() {
      return this.$state.settings.startupOptions.infoBackground || '';
    },
    infoContent() {
      return this.$state.settings.startupOptions.infoContent || '';
    }
  },
  methods: {
    close() {
      this.closing = true;
      let startApp = event => {
        this.$el.removeEventListener('transitionend', startApp);
        this.$state.persistence.watchStateForChanges();
        // Hacky to be using $parent but this component should only be used in a sepcific
        // scope within startup screens
        this.$parent.$emit('start');
      };
      this.$el.addEventListener('transitionend', startApp, false);
    }
  }
};
window._kiwi_exports = window._kiwi_exports || {};
if(!window._kiwi_exports["components"]) window._kiwi_exports["components"] = {};
if(!window._kiwi_exports["components"]["startups"]) window._kiwi_exports["components"]["startups"] = {};
window._kiwi_exports["components"]["startups"]["CommonLayout"]
window._kiwi_exports.components.startups.CommonLayout = exports.default ? exports.default : exports;
